/**
 * @generated SignedSource<<61394ed945b38e6775123bceab19183f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */
'use strict';

var node = function () {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pdfUniqueName"
  },
      v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "relationshipId"
  },
      v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "saveAsName"
  },
      v3 = [{
    "alias": null,
    "args": [{
      "kind": "Variable",
      "name": "pdfUniqueName",
      "variableName": "pdfUniqueName"
    }, {
      "kind": "Variable",
      "name": "relationshipId",
      "variableName": "relationshipId"
    }, {
      "kind": "Variable",
      "name": "saveAsName",
      "variableName": "saveAsName"
    }],
    "kind": "ScalarField",
    "name": "legalTermsUrl",
    "storageKey": null
  }];
  return {
    "fragment": {
      "argumentDefinitions": [v0
      /*: any*/
      , v1
      /*: any*/
      , v2
      /*: any*/
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "uploadPDFGetViewUrlQuery",
      "selections": v3
      /*: any*/
      ,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v1
      /*: any*/
      , v0
      /*: any*/
      , v2
      /*: any*/
      ],
      "kind": "Operation",
      "name": "uploadPDFGetViewUrlQuery",
      "selections": v3
      /*: any*/

    },
    "params": {
      "cacheID": "999637cbda89b742ef4ceef66e0c8b65",
      "id": null,
      "metadata": {},
      "name": "uploadPDFGetViewUrlQuery",
      "operationKind": "query",
      "text": "query uploadPDFGetViewUrlQuery(\n  $relationshipId: String\n  $pdfUniqueName: String!\n  $saveAsName: String\n) {\n  legalTermsUrl(relationshipId: $relationshipId, pdfUniqueName: $pdfUniqueName, saveAsName: $saveAsName)\n}\n"
    }
  };
}();

node.hash = "627416e60a67539032c7277e64d42d99";
module.exports = node;